/* src/app/components/header-menu/header-menu.component.scss */
.app-name {
  font-size: 30px;
  font-weight: normal;
  text-align: left;
  font-family: var(--holcim-regular) !important;
  color: var(--ion-color-primary-updated);
  margin: 0px;
}
.app-name strong {
  font-weight: bold;
  font-family: var(--holcim-headlineblack) !important;
}
.custom-header::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background:
    linear-gradient(
      90deg,
      #94c12e 15%,
      #007fad 50%,
      #041739 100%);
}
.menu-button {
  color: var(--ion-color-primary-updated) !important;
}
/*# sourceMappingURL=header-menu.component.css.map */
